import { useNavbarHeight } from "../../utils/contexts/NavbarContext";
import { scrollToIdWithOffset } from "../../lib/scrolling/ScrollToIdWithOffset";
import styles from "./Hero.module.css";

interface HeroSlide {
  imgSrc: string;
  imgAlt: string;
  linkedSectionId: string;
  buttonDisplay: string;
}

const heroSlides: HeroSlide[] = [
  {
    imgSrc: "/images/background/pho-bg-1.webp",
    imgAlt: "Bowl of pho",
    linkedSectionId: "featuredMenu",
    buttonDisplay: "Featured Menu",
  },
  {
    imgSrc: "/images/background/delivery-6.webp",
    imgAlt: "A man handing a package to a woman",
    linkedSectionId: "delivery",
    buttonDisplay: "Delivery",
  },
  {
    imgSrc: "/images/store/outside-front-1.webp",
    imgAlt: "Alo Asian Kitchen store front",
    linkedSectionId: "about",
    buttonDisplay: "About Us",
  },
];

function Hero() {
  const { navbarHeight } = useNavbarHeight();

  return (
    <section id="welcome" className={`container-fluid ${styles.hero}`}>
        <div className={`row g-4 px-3 px-lg-4 ${styles.heroRow}`}>        
            {heroSlides.map((slide, index) => (
                <div
                key={slide.linkedSectionId}
                className={`d-flex flex-column justify-content-center align-items-center ${styles.heroSlide}`}                
                >
                    <img
                    className={styles.slideBackground}
                    src={slide.imgSrc}
                    alt={slide.imgAlt}
                    decoding="async"
                    loading="eager"
                    {...({
                      fetchpriority: index === 0 ? "high" : "auto",
                    } as React.ImgHTMLAttributes<HTMLImageElement>)}                    
                    />

                    <div className="flex-grow-1" />

                    <a
                    className="btn-alo btn w-50 mb-5"
                    href={`#${slide.linkedSectionId}`}
                    onClick={(event) =>
                        scrollToIdWithOffset(slide.linkedSectionId, event, navbarHeight)
                    }
                    >
                    {slide.buttonDisplay}
                    </a>
                </div>
            ))}
      </div>
    </section>
  );
}

export default Hero;